import React from "react";
import { Segment, Dimmer, Loader, Image } from "semantic-ui-react";

const DimmerLoader: React.FC = () => {
    return (
        <Segment>
            <Dimmer active>
                <Loader size='medium' />
            </Dimmer>
            <Image src="https://react.semantic-ui.com/images/wireframe/short-paragraph.png" />
        </Segment>
    );
};

export default DimmerLoader;
